"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var icons = _interopRequireWildcard(require("@fortawesome/free-solid-svg-icons"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _v = _interopRequireDefault(require("uuid/v4"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Input =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Input, _React$Component);

  function Input(props) {
    var _this;

    _classCallCheck(this, Input);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Input).call(this, props));
    _this.state = {
      uuid: (0, _v.default)()
    };
    return _this;
  }

  _createClass(Input, [{
    key: "render",
    value: function render() {
      var toRender = this.defaultRender.bind(this);

      if (this.props.type === Input.types.radio) {
        toRender = this.radioRender.bind(this);
      }

      return _react.default.createElement("div", {
        className: this.wrapperClass()
      }, toRender());
    }
  }, {
    key: "defaultRender",
    value: function defaultRender() {
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("label", {
        className: "control-label",
        htmlFor: this.state.uuid
      }, this.props.label, this.renderRequired()), _react.default.createElement("input", {
        id: this.state.uuid,
        className: "form-control",
        type: this.props.type,
        disabled: this.props.disabled,
        placeholder: this.props.placeholder,
        value: this.props.value,
        onChange: this.props.onChange,
        required: this.props.required
      }), this.renderIcon(), this.renderHelp());
    }
  }, {
    key: "radioRender",
    value: function radioRender() {
      return _react.default.createElement("label", null, _react.default.createElement("input", {
        type: this.props.type,
        value: this.props.value,
        checked: this.props.checked,
        onChange: this.props.onChange
      }), this.props.label);
    }
  }, {
    key: "statusClass",
    value: function statusClass() {
      if (Input.contexts[this.props.context]) {
        return "has-".concat(Input.contexts[this.props.context]);
      }

      return '';
    }
  }, {
    key: "iconClass",
    value: function iconClass() {
      if (this.props.icon) {
        return 'has-feedback';
      }

      return '';
    }
  }, {
    key: "wrapperClass",
    value: function wrapperClass() {
      if (this.props.type === Input.types.radio) {
        return 'radio';
      }

      return "form-group ".concat(this.statusClass(), " ").concat(this.iconClass());
    }
  }, {
    key: "renderHelp",
    value: function renderHelp() {
      if (this.props.help) {
        return _react.default.createElement("span", {
          className: "help-block"
        }, this.props.help);
      }

      return null;
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      if (this.props.icon) {
        var icon = icons[this.props.icon];
        return _react.default.createElement("span", {
          className: "form-control-feedback"
        }, _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: icon
        }));
      }
    }
  }, {
    key: "renderRequired",
    value: function renderRequired() {
      if (this.props.required) {
        return _react.default.createElement("em", {
          className: "required-mark",
          "aria-hidden": "true",
          title: "Required"
        }, "*");
      }
    }
  }]);

  return Input;
}(_react.default.Component);

var types = ['button', 'checkbox', 'color', 'date', 'datetime-local', 'email', 'file', 'hidden', 'image', 'month', 'number', 'password', 'radio', 'range', 'reset', 'search', 'submit', 'tel', 'text', 'time', 'url', 'week'];
Input.contexts = {
  none: null,
  success: 'success',
  warning: 'warning',
  error: 'error'
};
Input.types = {};
types.forEach(function (t) {
  Input.types[t] = t;
});
Input.defaultProps = {
  type: Input.types.text,
  context: Input.contexts.none
};
Input.propTypes = {
  type: _propTypes.default.oneOf(Object.values(Input.types)),
  context: _propTypes.default.oneOf(Object.values(Input.contexts)),
  label: _propTypes.default.string,
  help: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  placeholder: _propTypes.default.string,
  onChange: _propTypes.default.func,
  icon: function icon(props, propName, componentName) {
    if (!props[propName]) {
      return null;
    }

    var matchingIcon = Object.values(icons).find(function (i) {
      return i.iconName === props[propName].iconName;
    });

    if (!matchingIcon) {
      return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". Not an icon within font awesome."));
    }

    return null;
  }
};
var _default = Input;
exports.default = _default;